import { NameValuePair } from "../models/base/NameValuePair";
import { stringTemplate } from "./stringTemplate";

/**
 * This is one of the most important class in the entire project.
 * This is to model the path of every collection and document in firestore.
 * K => stands for the type of the key
 * T => stands for the type of the entity the collection holds or the document refers to
 *
 * Ex: For an order
 *
 * Firestore Location => restaurants/{restaurantId}/stores/{storeId}/orders/{orderId}
 *
 * K => type OrderKey = { restaurantId: string, storeId: string, orderId: string }
 * T => type Order = { ... }
 * template (constructor argument) => restaurants/{restaurantId}/stores/{storeId}/orders/{orderId}
 *
 * NOTE: type parameter T is not used in this class, but checkout FirestoreTrigger where it is used.
 * It is a way to bring together the `key` and `entity` (this has tremendous benefits)
 * Checkout `firestore_paths` to see how it works.
 */
// K = Key, T = Entity that
export class FirestorePath<K extends NameValuePair<string>, _T> {
  //
  template: string;

  constructor(template: string) {
    this.template = template;
  }

  /**
   * Takes a key and returns a real path that points to a specific document or collection in firestore
   */
  path = (key: K) => {
    return stringTemplate.format(this.template, key);
  };
}
